import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";

function Name() {
  const { selectedObject } = useContext(AppContext);
  const { t } = useTranslation();
  const [name, setName] = useState(selectedObject?.get("name"));

  // triggered by clicking layers
  useEffect(() => {
    setName(selectedObject?.get("name"));
  }, [selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    if (value !== name && value !== "") {
      setName(value);
      selectedObject?.set("name", value);
    }
  }

  return (
    <input
      type="text"
      onChange={onChange}
      value={name}
      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      placeholder={t("properties_object_name_placeholder")}
    />
  );
}

export default Name;
